import { useState } from "react";
import { haveValue } from "../helper/common";
import { Outlet } from "react-router-dom";

const AuthRefresh = () => {
  const [loggedInId, setLoggedInId] = useState(null);

  setInterval(() => {
    const localId = localStorage.getItem("saveduserid");
    console.log(localId, loggedInId, "IN THEME PROVIDER");
    if (!haveValue(loggedInId) && haveValue(localId)) {
      setLoggedInId(localId);
    }
    if (haveValue(loggedInId) && haveValue(localId)) {
      if (loggedInId != localId) {
        window.location.replace(
          `${window.location.protocol}//${process.env.REACT_APP_URL_NAME}/home`
        );
      }
    }
  }, 10000);

  return (
    <>
      <Outlet />
    </>
  );
};

export default AuthRefresh;
